import { TextField as MuiTextField, type TextFieldProps } from '@mui/material'
import { type ChangeEvent, useEffect, useState } from 'react'
import { debouncedDispatch } from '@/redux/dispatchHelpers'
import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { selectField } from '../../selectors'
import { setValue } from '../../slice'
import type { FieldName } from '../../types'

type TFProps = {
  name: FieldName
} & TextFieldProps

export default function TextField({ name: _name }: TFProps) {
  const dispatch = useAppDispatch()
  const { field, value } = useAppSelector(selectField(_name))
  const [val, setVal] = useState(value)

  useEffect(
    function updateLocalStateOnStoreChange() {
      setVal(value)
    },
    [value],
  )

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setVal(event.target.value)
    debouncedDispatch(
      dispatch,
      setValue({ fieldName: _name, value: event.target.value }),
    )
  }

  return (
    <MuiTextField
      label={field.label}
      onChange={handleChange}
      value={val}
      fullWidth
    />
  )
}
